import React from "react";

import * as S from "./styles";

export const Equilibrio: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.FirstPhotosWrapper>
          <S.Photo1 />
          <S.Photo2 />
          <S.Credit>Alice Potts</S.Credit>
        </S.FirstPhotosWrapper>
        <S.Wrapper>
          <S.TextWrapper>
            <S.Text>
              <p>
                O resultado foram peças esculturais adornadas com cristais
                feitos de fluidos do corpo humano, que, algum dia, podem
                embelezar também nossas roupas. Através de uma abordagem que
                prioriza as relações humanas com a natureza e processos
                altamente experimentais, Alice também estuda como flores e
                alimentos desperdiçados podem se tornar bioplásticos.
              </p>

              <p>
                Quando perguntada sobre o que vislumbra para o futuro da moda,
                Alice sonha com um equilíbrio perfeito entre o fator humano, a
                biologia e a tecnologia. E também aborda o seu próprio conceito
                de “local”: “Acredito que os humanos vão projetar algo e isso
                será disponibilizado abertamente para todos, no mundo inteiro.
                Cada país poderá utilizar a tecnologia para materializar
                qualquer design nos materiais que estejam disponíveis naquele
                território. O design é o mesmo, porém o material com o qual
                produzimos pode ser diferente”.
              </p>
            </S.Text>
            <S.Text>
              <p>
                O meio de campo entre biotecnologia e moda projeta perspectivas
                animadoras e imagina novos caminhos sustentáveis para uma
                indústria que é, infelizmente, bem conhecida pela sua má pegada
                ambiental. Estamos entrando em uma nova era de inovação baseada
                na relação entre o humano e a natureza. Resta à moda perceber
                que buscar alternativas de materiais não é apenas uma tendência,
                mas uma urgência.
              </p>
            </S.Text>
          </S.TextWrapper>
        </S.Wrapper>
        <S.LastPhotosWrapper>
          <S.Credit className="last">Alice Potts</S.Credit>
          <S.Photo3 />
          <S.Photo4 />
          <S.Photo5 />
        </S.LastPhotosWrapper>
        <S.Wrapper className="last">
          <S.Title>
            Equilíbrio
            <br />
            perfeito
          </S.Title>
          <S.OneColumn>
            <S.Text className="light">
              <p>
                “Acredito que os humanos vão projetar algo e isso será
                disponibilizado abertamente para todos, no mundo inteiro. Cada
                país poderá utilizar a tecnologia para materializar qualquer
                design nos materiais que estejam disponíveis naquele território.
                O design é o mesmo, porém o material com o qual produzimos pode
                ser diferente”.
              </p>
              <p>
                <span>Alice Potts</span>
              </p>
            </S.Text>
          </S.OneColumn>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};
